import PropTypes from "prop-types";
import { format, addDays, parseISO } from "date-fns";
import { fromPricing, formatDateToMonthDay } from "helpers/formatting";
import cn from "classnames";
import Truncate from "solar/components/Truncate";
import Button from "solar/components/Button";
import styles from "components/stay/AvailabilityFixedVariant.module.scss";

export default function AvailabilityFixedVariant({
  price,
  usageDate,
  minNightStay,
  productId,
  productName,
  productPricingType,
  status,
  handleProductsModalOpen,
}) {
  const startDate = formatDateToMonthDay(usageDate);
  const endDate = format(
    addDays(parseISO(usageDate), minNightStay),
    "MMM d, yyyy"
  );

  return (
    <div
      className={cn(styles.variant, !status.available && styles.unavailable)}
    >
      <div className={styles.container}>
        <div className={styles.date}>{`${startDate} - ${endDate}`}</div>
        <div className={styles.name}>
          <Button link onClick={() => handleProductsModalOpen(productId)}>
            <Truncate clamp={1}>{productName}</Truncate>
          </Button>
        </div>
        <div className={styles.price}>
          {fromPricing(price, productPricingType)}
        </div>
        <div className={styles.count}>{status.count}</div>
        <div className={styles.action}>{status.action}</div>
      </div>
    </div>
  );
}

AvailabilityFixedVariant.propTypes = {
  price: PropTypes.string.isRequired,
  usageDate: PropTypes.string.isRequired,
  minNightStay: PropTypes.number.isRequired,
  productId: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  productPricingType: PropTypes.string.isRequired,
  status: PropTypes.shape({
    available: PropTypes.bool,
    count: PropTypes.string,
    action: PropTypes.node,
  }).isRequired,
  handleProductsModalOpen: PropTypes.func.isRequired,
};
